import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Star, CheckCircle2 } from 'lucide-react';
export const FloatingNotification = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [notificationData, setNotificationData] = useState({
    name: 'Marcela G.',
    location: 'Córdoba',
    product: 'Colección Completa 🔮',
    time: 'hace 9 minutos'
  });
  const buyers = [{
    name: 'Marcela G.',
    location: 'Córdoba',
    product: 'Colección Completa 🔮',
    time: 'hace 9 minutos'
  }, {
    name: 'Laura P.',
    location: 'Rosario',
    product: 'Colección Maestra',
    time: 'hace 14 minutos'
  }, {
    name: 'Pablo A.',
    location: 'Neuquén',
    product: 'Colección Completa 🔮',
    time: 'hace 22 minutos'
  }, {
    name: 'Romina M.',
    location: 'Buenos Aires',
    product: 'Colección Maestra',
    time: 'hace 35 minutos'
  }, {
    name: 'Luciana M.',
    location: 'CABA',
    product: 'Colección Completa 🔮',
    time: 'hace 41 minutos'
  }];
  useEffect(() => {
    // Initial delay before showing the first notification
    const initialTimer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    // Cycle notifications
    const cycleTimer = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
        // Randomize time slightly for realism
        const randomTime = `hace ${Math.floor(Math.random() * 59) + 1} minutos`;
        setNotificationData({
          ...randomBuyer,
          time: randomTime
        });
        setIsVisible(true);
      }, 1000); // Wait 1s before showing the next one
    }, 30000); // Show a new notification every 30 seconds
    return () => {
      clearTimeout(initialTimer);
      clearInterval(cycleTimer);
    };
  }, []);
  return <AnimatePresence data-id="element-80">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 400,
      damping: 25
    }} className="fixed bottom-4 left-4 md:bottom-8 md:left-8 z-50 max-w-sm" data-id="element-81">
          <div className="glass-panel bg-brand-surface/90 p-4 rounded-2xl shadow-2xl border-brand-gold/30 flex items-start space-x-4" data-id="element-82">
            <div className="bg-green-500/20 p-2 rounded-full shrink-0 mt-1" data-id="element-83">
              <CheckCircle2 className="w-5 h-5 text-green-600" data-id="element-84" />
            </div>
            <div data-id="element-85">
              <div className="text-xs text-brand-text/80 mb-1 flex items-center" data-id="element-86">
                Compra verificada • {notificationData.time}
              </div>
              <div className="text-sm font-medium text-brand-text mb-1" data-id="element-87">
                <span className="font-bold" data-id="element-88">{notificationData.name}</span> de{' '}
                {notificationData.location} compró
              </div>
              <div className="text-sm text-brand-gold font-medium" data-id="element-89">
                {notificationData.product}
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
};